import { Link, useParams } from 'react-router-dom';
import { NotFoundPage } from '../404.tsx';
import { useQuery } from '@tanstack/react-query';
import { getSittingSchedule } from '../../lib/api-client.ts';
import { Breadcrumb, Button, Card, Col, Descriptions, Row, Spin, Typography } from 'antd';

export const SittingDetailPage = () => {
  const { id } = useParams();

  if (!id) {
    return <NotFoundPage />;
  }

  const { data: sitting } = useQuery({ queryKey: ['sitting', id], queryFn: getSittingSchedule });

  if (!sitting) return <Spin />;

  return (
    <>
      <Breadcrumb
        style={{ margin: 16 }}
        items={[
          { title: <Link to="/">ホーム</Link> },
          { title: <Link to="/sittings">シッティング</Link> },
          { title: '詳細' },
        ]}
      />
      <Row gutter={[16, 16]} style={{ margin: 16 }}>
        <Col>
          <Typography.Title level={5}>シッティング予定</Typography.Title>
          <Card>
            <Descriptions>
              <Descriptions.Item label="親御様">{sitting.user.profile.name}様</Descriptions.Item>
              <Descriptions.Item label="日時">
                {sitting.startAt} ~ ({sitting.durationHours}時間)
              </Descriptions.Item>
              <Descriptions.Item label="住所">{sitting.user.profile.address}</Descriptions.Item>
              <Descriptions.Item label="備考">{sitting.memo}</Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>
        <Col>
          <Typography.Title level={5}>レポート</Typography.Title>
          {sitting.status === 'draft' && (
            <Button disabled type="primary" size="large">
              提出する
            </Button>
          )}
          {sitting.status === 'fixed' && (
            <Link to={`/sittings/${sitting.id}/report`}>
              <Button type="primary" size="large">
                提出する
              </Button>
            </Link>
          )}
          {sitting.status === 'done' && (
            <Button disabled type="primary" size="large">
              確認中
            </Button>
          )}
          {sitting.status === 'reported' && (
            <>
              <Button disabled type="primary" size="large">
                提出済
              </Button>
              <a
                href={`${import.meta.env.VITE_CROWN_URL}/previews/sitting/${sitting.record.id}?token=${sitting.record.token}`}
              >
                <Button type="link" size="large">
                  レポートを見る
                </Button>
              </a>
            </>
          )}
        </Col>
      </Row>
    </>
  );
};
